import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/metaPixel';
type CTAButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
export function CTAButton({
  label = 'GET THE YOGA READY PACK',
  className = '',
  href = '#offer'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: () => trackPixelEvent('InitiateCheckout', {
      value: 19,
      currency: 'USD'
    })
  } : {}} className={`inline-flex w-full items-center justify-center gap-3 rounded-full bg-terracotta px-6 py-4 text-[15px] font-bold uppercase tracking-[0.04em] text-cream shadow-sm transition-colors duration-200 hover:bg-[#d25a3c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal sm:w-auto sm:px-10 sm:text-base sm:tracking-[0.08em] ${className}`} data-id="element-72" data-mp="2g1xzud1hxpl0">
      {label}
      <ArrowRightIcon className="h-4 w-4 flex-none" aria-hidden="true" data-id="element-73" data-mp="19ahdmukcqt0c" />
    </a>;
}